import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';
import { createActions } from '../../../../store';

const WaveLayerRotationListItem = memo(({ index, rotation, updateWaveLayerCustomOptions }) => {
    const handleChange = useCallback(
        (value) => updateWaveLayerCustomOptions(index, "rotation", value),
        [index]
    );

    return (
        <SliderListItem
            title="Rotation"
            value={rotation}
            displayMultiplier={1}
            onValueChange={handleChange}
            min={0}
            max={360}
            step={1}
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { rotation } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;
    return { rotation };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerRotationListItem);
